export const useThemeStore = defineStore('theme', () => {
  const mode = ref<'light' | 'dark' | 'auto'>('auto')
  const color = ref<'gold' | 'indigo'>('indigo')
  
  const isDark = computed(() => {
    return mode.value === 'auto' ? usePreferredDark().value : mode.value === 'dark'
  })

  const colorMode = useColorMode({
    modes: {
      gold: 'light theme-gold',
      darkGold: 'dark theme-gold',
    },
  })

  watchEffect(() => {
    const themeMap = {
      indigo: isDark.value ? 'dark' : 'light',
      gold: isDark.value ? 'darkGold' : 'gold',
    } as const
    colorMode.value = themeMap[color.value]
  })

  return {
    mode,
    color,
    isDark,
  }
}, {
  persist: {
    key: 'theme-store',
    storage: localStorage,
    pick: ['mode', 'color'], // 只持久化这两个状态
  },
})
